const MASK = '***REDACTED***';

const SENSITIVE_KEYS = new Set([
  'password',
  'new_password',
  'current_password',
  'otp',
  'code',
  'token',
  'access_token',
  'refresh_token',
  'authorization',
  'account_id',
  'accountid',
  'api_key',
  'apikey',
  'dhanclientid',
  'clientid',
  'client_code',
  'clientcode',
]);

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return Object.prototype.toString.call(value) === '[object Object]';
}

export function maskSensitiveData<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map((item) => maskSensitiveData(item)) as T;
  }

  if (isPlainObject(value)) {
    const masked: Record<string, unknown> = {};
    Object.entries(value).forEach(([key, val]) => {
      if (SENSITIVE_KEYS.has(key.toLowerCase())) {
        masked[key] = MASK;
      } else {
        masked[key] = maskSensitiveData(val);
      }
    });
    return masked as T;
  }

  if (typeof value === 'string') {
    if (value.startsWith('Bearer ') || value.startsWith('encv1:')) {
      return MASK as T;
    }
    // Mask JWT-like token strings
    if (/^[A-Za-z0-9\-_]{10,}\.[A-Za-z0-9\-_]{10,}\.[A-Za-z0-9\-_]{10,}$/.test(value)) {
      return MASK as T;
    }
  }

  return value;
}
